export class Forbidden extends Error {}
